<template>
  <div>
    <v-card>
      <div v-padding="3">
        <div v-margin.bottom="1" v-margin.top="1">
          <v-text>
            Пакетная проверка — решение для разовой проверки большого количества
            субъектов.
          </v-text>
        </div>

        <div v-margin.bottom="2">
          <v-text type="title"
            >Пакетные запросы можно использовать в следующих сценариях:</v-text
          >
        </div>

        <div v-margin.bottom="1">
          <ul>
            <li>Проверка скоринга</li>
            <li>Проверка кредитного рейтинга</li>
            <li>Постановка на мониторинг</li>
          </ul>
        </div>

        <div v-margin.bottom="2">
          <v-text type="title">Преимущества пакетных проверок:</v-text>
        </div>

        <div v-margin.bottom="1">
          <ol>
            <li>Результаты представлены в виде агрегированной таблицы.</li>
            <li>
              Аналитика выборки, субъекты сегментированы по категориям риска.
            </li>
            <li>
              Стоимость ниже, чем если бы вы проверяли каждого субъекта вручную.
            </li>
          </ol>
        </div>

        <div v-margin.bottom="1" v-margin.top="1">
          <v-text>
            Свяжитесь с нами, чтобы получить подробную информацию о ценах и вариантах использования пакетных проверок в Unirate 24.
          </v-text>
        </div>        

        <div v-text-align.left v-margin.top="2">
          <v-button primary @click="requestPackage"> Оставить заявку </v-button>
        </div>

      </div>
    </v-card>
    <v-modal :active="isShowConfirm" @close="isShowConfirm = false">
      <div v-padding="2">
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2"> Спасибо </v-text>
        </div>
        <div v-margin.bottom="1">
          <v-text type="title" v-margin.bottom="2">
            Ваша заявка принята
          </v-text>
        </div>

        <div v-margin.bottom="1">
          <v-text v-margin.bottom="2">
            Мы свяжемся с вами в ближайшее время.
          </v-text>
        </div>

        <div v-text-align.right v-margin.top="1">
          <v-button flat @click="close"> Закрыть </v-button>
        </div>
      </div>
    </v-modal>
  </div>
</template>
<script>
import { requestPackage } from "../../../services/api/profile";
export default {
  name: "packageRequest",
  data() {
    return {
      isShowConfirm: false
    };
  },
  methods: {
    requestPackage() {
      requestPackage().then(() => {
        this.isShowConfirm = true;
      });
    },
    close() {
      this.isShowConfirm = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// PackageRequest.vue?786f4cd9